import React, { FunctionComponent, ReactElement, useState } from 'react';
import { IVisage2SocialPostType, SocialFeedContainer, SocialFeedType } from "src/social-feed";
import { InlineComposer } from "../Composer";
import { useSelector } from 'react-redux';

import "./SpintrSocialFeed.scss";
import classNames from 'classnames';
import { SpintrTypes } from 'src/typings';

interface IProps {
    feedId?: number;
    feedType: SocialFeedType;
    galleryId?: number;
    userId?: number;
    groupId?: number;
    identity?: any;
    isUnit?: boolean;
    isStartPage?: boolean;
    hideComposer?: boolean;
    composerFeedId?: number;
    composerIdentity?: any;
    composerPlaceholder?: string;
    composerHidePostTypes?: boolean;
    composerPostType?: IVisage2SocialPostType;
    displayResourceSelector?: boolean;
    displayTargetSelector?: boolean;
}

type StateProps = {
};

const SpintrSocialFeed: FunctionComponent<IProps> = (props: IProps): ReactElement => {
    const hideComposer = useSelector<Spintr.AppState, StateProps>((appState) => 
        appState.instance.get("restrictedSocialFeed") &&
        appState.profile.active.rights.canPostToFeed === false &&
        !(
            appState.instance.get("restrictedSocialFeedRestrictsAllCommenting") === false &&
            props.feedType === SocialFeedType.Group
        )
    );

    return (
        <div role="region" className={classNames("SpintrSocialFeed", {
            "without-composer": hideComposer || props.hideComposer,
        })}>
            {!props.hideComposer && !hideComposer && (
                <InlineComposer
                    feedId={props.composerFeedId || props.feedId}
                    galleryId={props.galleryId}
                    identity={props.composerIdentity || props.identity}
                    isUnit={props.isUnit}
                    isStartPage={props.isStartPage}
                    placeholder={props.composerPlaceholder}
                    hidePostTypes={props.composerHidePostTypes}
                    type={props.composerPostType}
                    displayResourceSelector={props.displayResourceSelector}
                    displayTargetSelector={props.displayTargetSelector}
                />
            )}
            <div className="social-post-feed">
                <SocialFeedContainer
                    feedId={props.feedId}
                    groupId={props.groupId}
                    feedType={props.feedType}
                    identity={props.identity}
                />
            </div>
        </div>
    );
};

export default SpintrSocialFeed
